import Repository from "../Repository";

const resource = "/bo/parameter/manpowers";
export default {
  // Gets technicians
  async get() {
    const { data } = await Repository.get(`${resource}`);
    return data;
  }
};
